import { render, staticRenderFns } from "./variation-report.vue?vue&type=template&id=5cf24952&"
import script from "./variation-report.vue?vue&type=script&lang=js&"
export * from "./variation-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports